import { render } from "./SubclienteLayout.vue?vue&type=template&id=4bc7abf7&scoped=true"
import script from "./SubclienteLayout.vue?vue&type=script&lang=js"
export * from "./SubclienteLayout.vue?vue&type=script&lang=js"

import "./SubclienteLayout.vue?vue&type=style&index=0&id=4bc7abf7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc7abf7"]])

export default __exports__